import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-organisation-profile',
  templateUrl: './organisation-profile.component.html',
  styleUrls: ['./organisation-profile.component.css']
})
export class OrganisationProfileComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/payroll/organisation-profile/organisation-profile.component.ts